export { EmplifiProductSocialWidget } from './emplifi-product-social-widget';
